// extracted by mini-css-extract-plugin
module.exports = {"body":"body--3eM1p","body__link":"body__link--1Hk3D","error":"error--2Rx94"};